export default "__VITE_ASSET__BVMmbwYw__"